import { useTranslations } from 'next-intl'
import { useCallback } from 'react'

import type { Plan, Project, Task } from '~/data/api/client/ticketing'

type IssueStatus = NonNullable<Task['status']>
type IssuePriority = NonNullable<Task['priority']>

export function useTicketStatusFormatter() {
  const t = useTranslations('operations')

  return useCallback(
    (status: IssueStatus): string => {
      switch (status) {
        case 'TODO':
          return t('ticketStatus_TODO')
        case 'IN_PROGRESS':
          return t('ticketStatus_IN_PROGRESS')
        case 'BLOCKED':
          return t('ticketStatus_BLOCKED')
        case 'DONE':
          return t('ticketStatus_DONE')
        default: {
          const unreachable: never = status
          return unreachable
        }
      }
    },
    [t]
  )
}

export function useTicketPriorityFormatter() {
  const t = useTranslations('operations')

  return useCallback(
    (priority: IssuePriority): string => {
      switch (priority) {
        case 'LOW':
          return t('priority_LOW')
        case 'MEDIUM':
          return t('priority_MEDIUM')
        case 'HIGH':
          return t('priority_HIGH')
        case 'URGENT':
          return t('priority_URGENT')
        default: {
          const unreachable: never = priority
          return unreachable
        }
      }
    },
    [t]
  )
}

export type ProjectStatus = NonNullable<Project['status']>

export function useProjectStatusFormatter() {
  const t = useTranslations('operations')

  return useCallback(
    (status: ProjectStatus): string => {
      switch (status) {
        case 'ACTIVE':
          return t('projectStatus_ACTIVE')
        case 'UPCOMING':
          return t('projectStatus_UPCOMING')
        case 'ON_HOLD':
          return t('projectStatus_ON_HOLD')
        case 'COMPLETED':
          return t('projectStatus_COMPLETED')
        default: {
          const unreachable: never = status
          return unreachable
        }
      }
    },
    [t]
  )
}

export type PlanStatus = NonNullable<Plan['status']>

export function usePlanStatusFormatter() {
  const t = useTranslations('operations')

  return useCallback(
    (status: PlanStatus): string => {
      switch (status) {
        case 'ACTIVE':
          return t('plans_statusActive')
        case 'PAUSED':
          return t('plans_statusPaused')
        case 'ARCHIVED':
          return t('plans_statusArchived')
        default: {
          const unreachable: never = status
          return unreachable
        }
      }
    },
    [t]
  )
}
